export const UNIQUE_X_AXIS_IDENTIFIER = "uniqueXAxis";
